import { render, staticRenderFns } from "./authorizedModal.vue?vue&type=template&id=6852b7b0&scoped=true&"
import script from "./authorizedModal.vue?vue&type=script&lang=js&"
export * from "./authorizedModal.vue?vue&type=script&lang=js&"
import style0 from "./authorizedModal.vue?vue&type=style&index=0&id=6852b7b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6852b7b0",
  null
  
)

export default component.exports